import { Company, UpdateCompanyReq, UpdateCompanyReqPayload } from './types';

export const formatUpdateCompanyDealDataForApiCall = (
  companyID: string,
  companyDetails: Company | undefined,
  valuesToUpdate: Partial<UpdateCompanyReqPayload>
): UpdateCompanyReq => ({
  company_id: companyID,
  payload: {
    registered_name: companyDetails?.registered_name,
    cin: companyDetails?.cin,
    registration_number: companyDetails?.registration_number,
    incorporated_in: companyDetails?.incorporated_in,
    currency: companyDetails?.currency,
    company_code: companyDetails?.company_code,
    company_known_name: companyDetails?.company_known_name,
    website: companyDetails?.website,
    company_one_liner: companyDetails?.company_one_liner,
    company_description: companyDetails?.company_description,
    hex_value: companyDetails?.hex_value,
    icon_url: companyDetails?.icon_url,
    company_stage: companyDetails?.company_stage,
    last_known_valuation: companyDetails?.last_known_valuation,
    last_funding_month: companyDetails?.last_funding_month,
    last_funding_year: companyDetails?.last_funding_year,
    total_funding_raised: companyDetails?.total_funding_raised,
    status: companyDetails?.status,
    ...valuesToUpdate
  }
});
